import { useContactPeople } from '../../hooks/useContactPeople';
import { useVal } from '../../val/val.client';
import contactSalesVal from '../../content/contactSales.val';
import ContactFooter from '../ContactFooter/ContactFooter';

const ContactSales: React.FC = () => {
  const { title, link } = useVal(contactSalesVal);
  const contactPeople = useContactPeople();

  return (
    <ContactFooter title={title} link={link} contactPeople={contactPeople} />
  );
};

export default ContactSales;
